// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GCyX","type":"styles_type__18ei5","choices":"styles_choices__28gKD"};